import { Button, Checkbox, Col, Row, Space, Form, message } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import InputBox from "../../../../components/common/input";
import DropdownSelect from "../../../../components/common/select";
import FileUpload from "../../../../components/common/upload-file/FileUpload";
import FileUploadFun from "../../../../components/common/fileUploadFun/FileUploadFun";
import { uploadFile } from "../../../../redux/reducer/UploadSlice";
import { useDispatch, useSelector } from "react-redux";
import { listSubscriptionFun } from "../../../../redux/reducer/SubscriptionSlice";
import {
  addPodcastCategory,
  listPodcastCategory,
  updatePodcastCategory,
  viewPodcastCategory,
} from "../../../../redux/reducer/PodcastCategorySlice";
import { toast } from "react-toastify";
import FileUploadTwo from "../../../../components/common/fileUploadFun/FileUploadTwo";

const AddCategory = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { fileUrl } = useSelector((state) => state.upload);
  const [previewImages, setPreviewImages] = useState(() => ({
    icon: "",
    icon_es: "",
    icon_pt: "",
  }));

  const { viewPodcastData, viewPodcastCategorydata } = useSelector(
    (prev) => prev?.podcastCategory
  );
  const editData = location?.state?.editData || null;

  useEffect(() => {
    if (viewPodcastCategorydata && editData) {
      form.setFieldsValue({
        name_en: viewPodcastCategorydata?.name_en,
        name_es: viewPodcastCategorydata?.name_es,
        name_pt: viewPodcastCategorydata?.name_pt,
        sequence: viewPodcastCategorydata?.sequence,
        subscription_ids: viewPodcastCategorydata?.subscription_ids,
        category_type: viewPodcastCategorydata?.type,
        icon: viewPodcastCategorydata?.icon,
        icon_es: viewPodcastCategorydata?.icon_es,
        icon_pt: viewPodcastCategorydata?.icon_pt,
        certificate_link: viewPodcastCategorydata?.certificate_link,

        // subscription_ids: Array.isArray(viewPodcastCategorydata.subscription_ids)
        //   ? viewPodcastCategorydata.subscription_ids.map((item) => item.id)
        //   : [],
        // sequence: viewPodcastCategorydata?.sequence,
        // icon: viewCategory.image_url || "https:www.pexels.com",
      });
      setPreviewImages((prev) => ({
        icon: viewPodcastCategorydata.icon
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastCategorydata?.icon}`
          : null,
        icon_es: viewPodcastCategorydata.icon_es
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastCategorydata?.icon_es}`
          : null,
        icon_pt: viewPodcastCategorydata.icon_pt
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewPodcastCategorydata?.icon_pt}`
          : null,
      }));
    } else {
      form.resetFields(); // Ensure blank form on add
    }
  }, [editData, viewPodcastCategorydata, form]);

  useEffect(() => {
    if (editData) {
      // dispatch(viewHomeCategory(editData?.id));
      dispatch(viewPodcastCategory(editData?.id));
    }
  }, [dispatch, editData]);

  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  };

  useEffect(() => {
    dispatch(listSubscriptionFun());
  }, []);

  const { listSubscription, listSubLoading, listSubError } = useSelector(
    (state) => state?.subscription
  );

  const listSubscriptionData = listSubscription.map(({ id, name_en }) => ({
    label: name_en,
    value: id,
  }));

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const payload = {
        name_en: values?.name_en,
        name_es: values?.name_es,
        name_pt: values?.name_pt,
        sequence: values?.sequence,
        subscription_ids: values?.subscription_ids,
        type: values?.category_type,
        certificate_link: values?.certificate_link,
        icon: values?.icon,
        icon_es: values?.icon_es,
        icon_pt: values?.icon_pt,
      };

      if (editData) {
        const response = await dispatch(
          updatePodcastCategory({ id: editData?.id, data: payload })
        );
        if (response.type === "data/update/podcastCategory/fulfilled") {
          toast.success("Podcast category updated successfully");
          navigate(-1);
        }
      } else {
        const response = await dispatch(addPodcastCategory(payload));
        if (response.payload.code === 201) {
          toast.success(response?.payload?.message);
          navigate("/manage-category");
        } else {
          toast.error(response?.payload?.message);
        }
      }

      // tenentData
      // if (tenentDetails) {
      //  const response =  await dispatch(updateTenantFun({ id: tenentDetails?.id, data: payload }));

      //  if(response.type === "data/update/tenant/fulfilled"){
      //   toast.success("Tenant update succesfully")
      //   navigate('/tenant-mgmnt')
      //  }
      // } else{
      // const response = await dispatch(addTenantFun(payload));

      // if(response.payload.code === 201){
      //   toast.success(response?.payload?.message)
      //   navigate('/tenant-mgmnt')
      // }
      // else{
      //   toast.error(response?.payload?.message)
      // }

      // }
    } catch (error) {
      message.error("Error adding tenant!");
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const categoryTypeData = [
    { label: "Category", value: 1 },
    { label: "Product", value: 0 },
    { label: "Collection", value: 2 },
  ];

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">
          {editData ? "Edit" : "Add"} Category Details
        </div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()}>
            {editData ? "Update" : "Save"} Details
          </Button>
        </Space>
      </div>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
              name="name_en"
              label="Category Name (en)"
              rules={[
                { required: true, message: "Please enter category name" },
              ]}
            >
              <InputBox size="large" placeholder="Enter category name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="name_es"
              label="Category Name (es)"
              rules={[
                { required: true, message: "Please enter category name" },
              ]}
            >
              <InputBox size="large" placeholder="Enter category name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="name_pt"
              label="Category Name (pt)"
              rules={[
                { required: true, message: "Please enter category name" },
              ]}
            >
              <InputBox size="large" placeholder="Enter category name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="category_type"
              label="Category Type"
              rules={[{ required: true, message: "Select a category" }]}
            >
              <DropdownSelect
                value={form.getFieldValue("category_type")}
                onChange={(value) =>
                  form.setFieldsValue({ category_type: value })
                }
                options={categoryTypeData}
                placeholder="Choose..."
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="sequence"
              label="Category Sequence"
              rules={[
                { required: true, message: "Please enter category sequence" },
                {
                  pattern: /^[1-9][0-9]*$/,
                  message: "Only positive integers are allowed",
                },
              ]}
            >
              <InputBox size="large" placeholder="Enter category sequence" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="subscription_ids"
              label="Add To Plan"
              rules={[{ required: true, message: "Select a subscription" }]}
            >
              <DropdownSelect
                options={listSubscriptionData}
                placeholder="Choose..."
                mode="multiple"
                value={form.getFieldValue("subscription_ids")}
                onChange={(value) =>
                  form.setFieldsValue({ subscription_ids: value })
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="certificate_link" label="Evaluation URL">
              <InputBox size="large" placeholder="Enter evaluation url" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={16}></Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="icon"
              label="Upload Icon (en)"
              rules={[{ required: true, message: "Please upload a icon" }]}
            >
              <FileUploadTwo
                // label2={"Upload Icon (en)"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) => handleUploadSuccess("icon", url)}
                initialPreview={previewImages.icon}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="icon_es"
              label="Upload Icon (es)"
              rules={[{ required: true, message: "Please upload a icon" }]}
            >
              <FileUploadTwo
                // label2={"Upload Icon (en)"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) => handleUploadSuccess("icon_es", url)}
                initialPreview={previewImages?.icon_es}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="icon_pt"
              label="Upload Icon (pt)"
              rules={[{ required: true, message: "Please upload a icon" }]}
            >
              <FileUploadTwo
                // label2={"Upload Icon (en)"}
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) => handleUploadSuccess("icon_pt", url)}
                initialPreview={previewImages?.icon_pt}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddCategory;
